import axiosInstance from "../axios/axios_instance";
const http = axiosInstance("/public",  null, null);

const setAffiliate = (affiliateName) =>
    http.post("/affiliate_cookie", { affiliate: affiliateName }).then((res) => {
        if (res.data?.token) {
            localStorage.setItem("affiliateToken", res.data.token);
        }
        return res;
    });

export default {
    setAffiliate
};